module.exports = __webpack_public_path__ + "static/media/photo.b45060ac.svg";